<div class="flex flex-col w-full bg-gray-100 h-full">
  @for (item of menuItems; track item.path) {
    <a
      [routerLink]="item.path"
      class="flex flex-col items-center justify-center py-4 hover:bg-gray-200 transition"
    >
      <ng-container *ngComponentOutlet="item.icon"></ng-container>

      <span class="text-[0.55rem] text-center">
        {{ item.label }}
      </span>
    </a>
  }
</div>